/* Chemical Anchor Selector — AIMS Industrial
   Hobson anchor data, cure table and decision logic are a direct port of
   AIMS_ChemicalAnchorSelector_Tool_27Aug26.html. Every spec still traces to Hobson 190906DS.

   One substantive change: price and stock are refreshed from Shopify's own
   /products/<handle>.js when a result renders, rather than trusted from the baked-in values.
   All 33 entries were correct when checked, but hardcoded pricing goes stale on its own.
   The baked-in figures remain as a fallback if the fetch fails.

   Everything is inside one IIFE: nothing is added to window. */
(function () {
  'use strict';

  var SITE = '';                 // same-origin, so the tool works on preview themes too
  var cache = {}, inflight = {};

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function refreshLive(root, handles) {
    handles.forEach(function (h) {
      if (cache[h]) { apply(root, cache[h]); return; }
      if (inflight[h]) return;
      inflight[h] = true;
      fetch('/products/' + h + '.js', { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (p) { cache[h] = p; apply(root, p); })
        .catch(function () { /* keep the baked-in fallback */ })
        .then(function () { inflight[h] = false; });
    });
  }

  function apply(root, product) {
    (product.variants || []).forEach(function (v) {
      var id = String(v.id);
      var p = root.querySelector('[data-ca-price="' + id + '"]');
      if (p && typeof v.price === 'number') p.textContent = money(v.price);
      var s = root.querySelector('[data-ca-stock="' + id + '"]');
      if (s) {
        s.textContent = v.available ? 'In stock' : 'Out of stock';
        s.classList.toggle('in', !!v.available);
        s.classList.toggle('out', !v.available);
        var row = s.closest('.ca-sku-row');
        if (row) row.classList.toggle('is-oos', !v.available);
      }
    });
  }

  function init(root) {




    // Drill bit fields carry a variantId so links land on the exact diameter, not a default
    // variant a "hide sold out" theme setting might swap out from under the customer.
    // "sds" = rotary-hammer bit (SDS Plus for M8-M20, SDS Max for M24 — different shank, flagged in copy).
    // "standard" = round/straight shank bit for a standard hammer drill chuck — null where AIMS
    // doesn't stock that exact diameter in the straight-shank range (tops out at 25mm).
    var ANCHOR_DATA = {
      M8:  { hole:10, embed:80,  studLen:110, fixClear:9,  brush:12, maxFix:17, minBase:110, minSpacing:40,
             sds:{ diam:10, shank:"SDS Plus", handle:"bordo-sds-plus-masonry-drill-bit-110-260mm", variantId:"49337991299349", sku:"A0197769", price:13.41 },
             standard:{ diam:10, handle:"bordo-straight-shank-masonry-drill-bit-double-brick", variantId:"49337982877973", sku:"A0197753", price:39.71 } },
      M10: { hole:12, embed:90,  studLen:130, fixClear:12, brush:14, maxFix:25, minBase:120, minSpacing:50,
             sds:{ diam:12, shank:"SDS Plus", handle:"bordo-sds-plus-masonry-drill-bit-110-260mm", variantId:"49337991561493", sku:"A0197777", price:19.67 },
             standard:{ diam:12, handle:"bordo-straight-shank-masonry-drill-bit-double-brick", variantId:"49337982910741", sku:"A0197754", price:39.71 } },
      M12: { hole:14, embed:110, studLen:160, fixClear:14, brush:16, maxFix:32, minBase:140, minSpacing:60,
             sds:{ diam:14, shank:"SDS Plus", handle:"bordo-sds-plus-masonry-drill-bit-110-260mm", variantId:"49337992184085", sku:"A0197796", price:35.79 },
             standard:{ diam:14, handle:"bordo-straight-shank-masonry-drill-bit-double-brick", variantId:"49337982976277", sku:"A0197756", price:57.94 } },
      M16: { hole:18, embed:125, studLen:190, fixClear:18, brush:20, maxFix:43, minBase:161, minSpacing:80,
             sds:{ diam:18, shank:"SDS Plus", handle:"bordo-sds-plus-x-bit-masonry-drill-bit", variantId:"49324642140437", sku:"A0205378", price:119.37 },
             standard:{ diam:18, handle:"bordo-straight-shank-masonry-drill-bit-double-brick", variantId:"49337983041813", sku:"A0197758", price:79.35 } },
      M20: { hole:24, embed:170, studLen:260, fixClear:22, brush:26, maxFix:64, minBase:218, minSpacing:100,
             sds:{ diam:24, shank:"SDS Plus", handle:"bordo-sds-plus-x-bit-masonry-drill-bit", variantId:"49324642238741", sku:"A0205381", price:184.10 },
             standard:null },
      M24: { hole:28, embed:210, studLen:300, fixClear:26, brush:30, maxFix:59, minBase:266, minSpacing:120,
             sds:{ diam:28, shank:"SDS Max", handle:"bordo-sds-max-masonry-drill-bit", variantId:"49338032718101", sku:"A0197833", price:270.24 },
             standard:null }
    };

    var DRILL_COLLECTION_URL = SITE + "/collections/masonry-drill-bit-sets";

    var SKU_DATA = {
      M8: [
        {label:"Zinc Yellow, Class 5.8", handle:"metric-stud-chemical-anchor-kit-grade-5-8-zinc-yellow-finish", variantId:"49274527252757", sku:"A0096468", price:6.64, stock:true},
        {label:"Hot-Dip Galvanised, Class 5.8 (box of 10)", handle:"m8-x-110mm-stud-chemical-anchor-kit-cl5-8-chisel-point-hdg-box-of-10", variantId:"49293847167253", sku:"A0141394", price:7.01, stock:true}
      ],
      M10: [
        {label:"Zinc Yellow, Class 5.8", handle:"metric-stud-chemical-anchor-kit-grade-5-8-zinc-yellow-finish", variantId:"49274527285525", sku:"A0096473", price:12.37, stock:true},
        {label:"Hot-Dip Galvanised, Class 5.8", handle:"metric-stud-chemical-anchor-kit-grade-5-8-hot-dip-galvanised-finish", variantId:"49274524074261", sku:"A0096471", price:11.07, stock:true},
        {label:"Galvanised, Flat Cut, Class 5.8", handle:"metric-galvanised-flat-cut-stud-chemical-anchor", variantId:"49292727255317", sku:"A0096472", price:12.33, stock:true},
        {label:"HDG, Class 8 (higher grade)", handle:"stud-chemical-anchor-kit-flat-top-angle-cut-pt-cl-8-hdg", variantId:"49295462826261", sku:"A0141288", price:14.53, stock:true}
      ],
      M12: [
        {label:"Zinc Yellow, Class 5.8", handle:"metric-stud-chemical-anchor-kit-grade-5-8-zinc-yellow-finish", variantId:"49274527318293", sku:"A0096479", price:14.39, stock:true},
        {label:"Hot-Dip Galvanised, Class 5.8", handle:"metric-stud-chemical-anchor-kit-grade-5-8-hot-dip-galvanised-finish", variantId:"49274524107029", sku:"A0096477", price:15.50, stock:true},
        {label:"Galvanised, Flat Cut, Class 5.8", handle:"metric-galvanised-flat-cut-stud-chemical-anchor", variantId:"49292727288085", sku:"A0096478", price:16.44, stock:false},
        {label:"HDG, Class 8 (higher grade)", handle:"stud-chemical-anchor-kit-flat-top-angle-cut-pt-cl-8-hdg", variantId:"49295462859029", sku:"A0141289", price:20.35, stock:true}
      ],
      M16: [
        {label:"Zinc Yellow, Class 5.8", handle:"metric-stud-chemical-anchor-kit-grade-5-8-zinc-yellow-finish", variantId:"49274527351061", sku:"A0096485", price:33.03, stock:true},
        {label:"Hot-Dip Galvanised, Class 5.8", handle:"metric-stud-chemical-anchor-kit-grade-5-8-hot-dip-galvanised-finish", variantId:"49274524139797", sku:"A0096483", price:32.29, stock:false},
        {label:"Galvanised, Flat Cut, Class 5.8", handle:"metric-galvanised-flat-cut-stud-chemical-anchor", variantId:"49292727320853", sku:"A0096484", price:38.07, stock:true},
        {label:"HDG, Class 8 (higher grade)", handle:"stud-chemical-anchor-kit-flat-top-angle-cut-pt-cl-8-hdg", variantId:"49295462891797", sku:"A0141290", price:42.08, stock:true},
        {label:"Capsule only (Bremick) — bring your own stud", handle:"16mm-plain-chemical-capsule-to-suit-m16-anchor-studs-box-of-10", variantId:"49324539379989", sku:"A0096481", price:39.62, stock:true}
      ],
      M20: [
        {label:"Zinc Yellow, Class 5.8", handle:"metric-stud-chemical-anchor-kit-grade-5-8-zinc-yellow-finish", variantId:"49274527383829", sku:"A0096491", price:61.82, stock:true},
        {label:"Hot-Dip Galvanised, Class 5.8", handle:"metric-stud-chemical-anchor-kit-grade-5-8-hot-dip-galvanised-finish", variantId:"49274524172565", sku:"A0096489", price:62.56, stock:true},
        {label:"Galvanised, Flat Cut, Class 5.8", handle:"metric-galvanised-flat-cut-stud-chemical-anchor", variantId:"49292727353621", sku:"A0096490", price:82.23, stock:true},
        {label:"HDG, Class 8 (higher grade)", handle:"stud-chemical-anchor-kit-flat-top-angle-cut-pt-cl-8-hdg", variantId:"49295462924565", sku:"A0141291", price:93.00, stock:true}
      ],
      M24: [
        {label:"Zinc Yellow, Class 5.8", handle:"metric-stud-chemical-anchor-kit-grade-5-8-zinc-yellow-finish", variantId:"49274527416597", sku:"A0096497", price:49.92, stock:true},
        {label:"Hot-Dip Galvanised, Class 5.8", handle:"metric-stud-chemical-anchor-kit-grade-5-8-hot-dip-galvanised-finish", variantId:"49274524205333", sku:"A0096495", price:55.36, stock:true},
        {label:"Galvanised, Flat Cut, Class 5.8", handle:"metric-galvanised-flat-cut-stud-chemical-anchor", variantId:"49292727386389", sku:"A0096496", price:63.73, stock:true},
        {label:"HDG, Class 8 (higher grade)", handle:"stud-chemical-anchor-kit-flat-top-angle-cut-pt-cl-8-hdg", variantId:"49295462957333", sku:"A0141292", price:78.09, stock:true}
      ]
    };

    var CURE_TABLE = {
      "5":  {working:"30–45 min", cure:"4–6 hrs"},
      "10": {working:"15–25 min", cure:"2–3 hrs"},
      "20": {working:"6–10 min",  cure:"45–60 min"},
      "30": {working:"4–6 min",   cure:"30–45 min"},
      "40": {working:"2–4 min",   cure:"20–30 min"}
    };

    var SIZES = ["M8","M10","M12","M16","M20","M24"];

    function $(id){ return root.querySelector('[data-ca-el="' + id + '"]'); }
    function fmtPrice(p){ return "$" + p.toFixed(2); }

    function showPanel(id){
      root.querySelectorAll(".ca__panel").forEach(function(p){ p.classList.remove("is-active"); });
      $(id).classList.add("is-active");
      if (root.getBoundingClientRect().top < 0) { root.scrollIntoView({behavior:"smooth", block:"start"}); }
    }

    root.querySelectorAll("[data-go]").forEach(function(btn){
      btn.addEventListener("click", function(){
        var target = btn.getAttribute("data-go");
        showPanel("panel-" + target);
      });
    });
    root.querySelectorAll("[data-back]").forEach(function(btn){
      btn.addEventListener("click", function(){
        showPanel(btn.getAttribute("data-back"));
      });
    });

    // Build size grid
    var sizeGrid = $("sizeGrid");
    SIZES.forEach(function(size){
      var d = ANCHOR_DATA[size];
      var b = document.createElement("button");
      b.className = "ca-size-btn";
      b.innerHTML = size + '<span class="ca-size-hint">' + d.hole + 'mm hole</span>';
      b.addEventListener("click", function(){ renderResults(size); showPanel("panel-results"); });
      sizeGrid.appendChild(b);
    });

    // Guided Q1
    root.querySelectorAll("[data-duty]").forEach(function(btn){
      btn.addEventListener("click", function(){
        var duty = btn.getAttribute("data-duty");
        if (duty === "heavy"){
          showPanel("panel-heavyStop");
          return;
        }
        renderSuggestion(duty);
        showPanel("panel-suggest");
      });
    });

    function renderSuggestion(duty){
      var title, body, sizes;
      if (duty === "light"){
        title = "Light duty — start around M8–M10";
        body = "For handrails, shelf brackets and light, non-structural fittings, M8 or M10 is the usual starting point. Pick a size below to see the full spec, or step back if your job feels heavier than this.";
        sizes = ["M8","M10"];
      } else {
        title = "Medium duty — start around M12–M16";
        body = "For machinery mounts, structural steel base plates and stair or balustrade posts, M12 or M16 is the common range. Pick a size below to see the full spec.";
        sizes = ["M12","M16"];
      }
      $("suggestTitle").textContent = title;
      $("suggestBody").innerHTML = body + ' This is a starting point only, not an engineering calculation — for anything load-bearing, confirm the required size against a structural drawing or AS&nbsp;5216 documentation.';
      var btnWrap = $("suggestBtns");
      btnWrap.innerHTML = "";
      sizes.forEach(function(size){
        var b = document.createElement("button");
        b.className = "ca-chip-btn";
        b.textContent = size;
        b.addEventListener("click", function(){ renderResults(size); showPanel("panel-results"); });
        btnWrap.appendChild(b);
      });
    }

    var currentSize = null;

    function renderResults(size){
      currentSize = size;
      var d = ANCHOR_DATA[size];
      $("resSize").innerHTML = size + '<span class="ca-unit">chemical stud anchor</span>';

      var specGrid = $("specGrid");
      specGrid.innerHTML = "";
      var items = [
        ["Hole diameter", d.hole, "mm"],
        ["Embedment depth", d.embed, "mm"],
        ["Stud length", d.studLen, "mm"],
        ["Min. base material depth", d.minBase, "mm"],
        ["Max. fixture thickness", d.maxFix, "mm"],
        ["Wire brush diameter", d.brush, "mm"],
        ["Min. edge distance", d.minSpacing, "mm"],
        ["Min. anchor spacing", d.minSpacing, "mm"]
      ];
      items.forEach(function(it){
        var el = document.createElement("div");
        el.className = "ca-spec-item";
        el.innerHTML = '<div class="ca-s-label">' + it[0] + '</div><div class="ca-s-value">' + it[1] + '<span class="ca-s-unit">' + it[2] + '</span></div>';
        specGrid.appendChild(el);
      });
      $("specNote").innerHTML = "Figures per Hobson Engineering's Chemical Stud Anchors data sheet (190906DS) for the " + size + " chemical stud anchor. AIMS doesn't currently stock a matching round wire hole-cleaning brush for this size (" + d.brush + "mm) &mdash; a straight bottle-style wire brush of this diameter from any trade supplier will do the job.";

      // Temperature picker
      var tempRow = $("tempRow");
      tempRow.innerHTML = "";
      $("cureResult").classList.remove("show");
      Object.keys(CURE_TABLE).forEach(function(t){
        var b = document.createElement("button");
        b.className = "ca-temp-btn";
        b.textContent = t + "°C";
        b.addEventListener("click", function(){
          tempRow.querySelectorAll(".temp-btn").forEach(function(x){ x.classList.remove("is-selected"); });
          b.classList.add("is-selected");
          var c = CURE_TABLE[t];
          var cr = $("cureResult");
          cr.innerHTML = '<div class="ca-cure-item"><div class="ca-c-label">Working time</div><div class="ca-c-value">' + c.working + '</div></div>' +
                          '<div class="ca-cure-item"><div class="ca-c-label">Full cure before loading</div><div class="ca-c-value">' + c.cure + '</div></div>';
          cr.classList.add("show");
        });
        tempRow.appendChild(b);
      });

      // SKU list
      var skuList = $("skuList");
      skuList.innerHTML = "";
      var skus = SKU_DATA[size] || [];
      skus.forEach(function(s){
        var row = document.createElement("div");
        row.className = "ca-sku-row" + (s.stock ? "" : " oos");
        row.innerHTML =
          '<div class="ca-sku-main"><span class="ca-sku-name">' + s.label + '</span><span class="ca-sku-meta">SKU ' + s.sku + '</span></div>' +
          '<div class="ca-sku-right">' +
            '<span class="ca-stock ' + (s.stock ? "in" : "out") + '" data-ca-stock="' + s.variantId + '">' + (s.stock ? "In stock" : "Out of stock") + '</span>' +
            '<span class="ca-price" data-ca-price="' + s.variantId + '">' + fmtPrice(s.price) + '</span>' +
            '<a class="ca-sku-link" href="' + SITE + '/products/' + s.handle + '?variant=' + s.variantId + '" target="_blank" rel="noopener">View</a>' +
          '</div>';
        skuList.appendChild(row);
      });

      // Drill bit note — links go straight to the matching diameter/length variant so the
      // customer lands on the exact option, not whichever variant the product page defaults to.
      // Two rows: rotary hammer (SDS) bit, and a standard round-shank bit where AIMS stocks one.
      var dn = $("drillNote");
      var sds = d.sds;
      var sdsLink = SITE + '/products/' + sds.handle + '?variant=' + sds.variantId;
      var sdsShankNote = sds.shank === "SDS Max"
        ? ' — a different shank to the SDS Plus drills used for the smaller sizes above; needs an SDS Max-compatible rotary hammer.'
        : '';
      var rowsHtml = '<div class="ca-drillbit-row"><span class="ca-db-text">Rotary hammer (<b>' + sds.diam + 'mm ' + sds.shank + '</b>)' + sdsShankNote + ' — <a href="' + sdsLink + '" target="_blank" rel="noopener">view it here</a></span><span class="ca-db-price">' + fmtPrice(sds.price) + '</span></div>';

      var std = d.standard;
      if (std){
        var stdLink = SITE + '/products/' + std.handle + '?variant=' + std.variantId;
        rowsHtml += '<div class="ca-drillbit-row"><span class="ca-db-text">Standard hammer drill (<b>' + std.diam + 'mm straight shank</b>) — <a href="' + stdLink + '" target="_blank" rel="noopener">view it here</a></span><span class="ca-db-price">' + fmtPrice(std.price) + '</span></div>';
      } else {
        rowsHtml += '<div class="ca-drillbit-row"><span class="ca-db-text ca-db-gap">AIMS doesn\'t stock a ' + d.hole + 'mm straight-shank bit — the range tops out around 25mm, so a rotary hammer (SDS) bit is the only exact match at this size.</span></div>';
      }

      rowsHtml += '<div class="ca-drillbit-collection">Not the right length or finish? <a href="' + DRILL_COLLECTION_URL + '" target="_blank" rel="noopener">browse the full masonry drill bit range</a>.</div>';
      dn.innerHTML = rowsHtml;
    }

    $("startAgainBtn").addEventListener("click", function () {
      var cr = $("cureResult"); if (cr) cr.classList.remove("show");
      var sel = root.querySelectorAll(".is-selected");
      for (var i = 0; i < sel.length; i++) sel[i].classList.remove("is-selected");
      showPanel("panel-entry");
    });


    /* Wrap renderResults so price and stock refresh from live data after every render.
       Defined before the initial render below, so even the default M12 view is live. */
    var _renderResults = renderResults;
    renderResults = function (size) {
      _renderResults(size);
      var hs = [];
      (SKU_DATA[size] || []).forEach(function (s) { if (hs.indexOf(s.handle) === -1) hs.push(s.handle); });
      var d = ANCHOR_DATA[size];
      if (d && d.sds && hs.indexOf(d.sds.handle) === -1) hs.push(d.sds.handle);
      if (d && d.standard && hs.indexOf(d.standard.handle) === -1) hs.push(d.standard.handle);
      refreshLive(root, hs);
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'chem_anchor_lookup', { stud_size: size });
      }
    };

    renderResults("M12");
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ca]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].getAttribute('data-ca-ready') === '1') continue;
      roots[i].setAttribute('data-ca-ready', '1');
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
